<script>
    import Fa from 'svelte-fa';
    import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

    import Accordian from '$lib/components/Accordian.svelte';
    import AccordianItem from '$lib/components/AccordianItem.svelte';

    export let variants;
    export let available;

    // filter variants and build array for inStock options
    const stockArray = variants.reduce((accumulator, item) => {
        const stockShowOptions = item.selectedOptions.filter((option) => ['Strength', 'Colour', 'Resistance Ω'].includes(option.name));

        stockShowOptions.forEach((option) => {
            const index = accumulator.findIndex((entry) => entry.name === option.name);

            if (index !== -1) {
                accumulator[index].options.push({
                    value: option.value,
                    available: item.quantityAvailable
                });

                // Sort options array in numeric order
                accumulator[index].options.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
            } else {
                accumulator.push({
                    name: option.name,
                    options: [
                        {
                            value: option.value,
                            available: item.quantityAvailable
                        }
                    ]
                });
            }
        });

        return accumulator;
    }, []);
</script>

{#if stockArray.length}
    <Accordian>
        <AccordianItem key="0" showIcon={false}>
            <div slot="header">
                <span class="text-sm text-color-text/80">Availability</span>
                <table>
                    <tbody>
                        <tr>
                            <td class="w-24"
                                ><span>{`${available ? 'In Stock' : 'No Stock'}`}</span>
                                <span class={`ml-1 inline-block h-2.5 w-2.5 rounded-full ${available ? 'bg-green-400' : 'bg-red-400'}`} /></td
                            >
                            <td><span>Check Stock Levels <Fa icon={faChevronDown} class="ml-1 inline-block" /></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <table class="mt-4 w-full table-fixed border-collapse overflow-hidden rounded-lg text-center" slot="body">
                {#each stockArray as item (item)}
                    <thead class="bg-base-800">
                        <tr>
                            <th class="p-2 font-semibold">{item.name}</th>
                            <th class="p-2 font-semibold">In Stock</th>
                        </tr>
                    </thead>
                    <tbody class="bg-base-800/70">
                        {#each item.options as value (value)}
                            <tr class="border-b border-base-900/80 last-of-type:border-none">
                                <td class="p-2">{value.value}</td>
                                <td class="p-2">
                                    <div class="flex items-center justify-center">
                                        <span
                                            class={`mr-4 inline-block h-2.5 w-2.5 rounded-full ${
                                                value.available >= 10
                                                    ? 'bg-green-400'
                                                    : value.available < 10 && value.available > 0
                                                      ? 'bg-orange-400'
                                                      : value.available <= 0
                                                        ? 'bg-red-400'
                                                        : ''
                                            }`}
                                        />
                                        <span>
                                            {`${
                                                value.available >= 30
                                                    ? '30+'
                                                    : value.available < 30 && value.available > 9
                                                      ? '10+'
                                                      : value.available <= 0
                                                        ? '0'
                                                        : value.available
                                            }`}
                                        </span>
                                    </div></td
                                >
                            </tr>
                        {/each}
                    </tbody>
                {/each}
            </table>
        </AccordianItem>
    </Accordian>
{/if}
